import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 16,
	viewBox: "0 0 14 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		opacity: .6,
		d: "M1 4.11111H13M5.5 7.22222V11.8889M8.5 7.22222V11.8889M1.75 4.11111L2.5 13.4444C2.5 13.857 2.65804 14.2527 2.93934 14.5444C3.22064 14.8361 3.60218 15 4 15H10C10.3978 15 10.7794 14.8361 11.0607 14.5444C11.342 14.2527 11.5 13.857 11.5 13.4444L12.25 4.11111M4.75 4.11111V1.77778C4.75 1.5715 4.82902 1.37367 4.96967 1.22781C5.11032 1.08194 5.30109 1 5.5 1H8.5C8.69891 1 8.88968 1.08194 9.03033 1.22781C9.17098 1.37367 9.25 1.5715 9.25 1.77778V4.11111",
		stroke: "#1D1D1F",
		strokeWidth: 1.66362,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTrash;
